import { c as _c } from "react/compiler-runtime";
import Dialog from './Dialog';
import PageMain from './PageMain';
import PagePhone from './PagePhone';
import PageEmail from './PageEmail';
import PageCompanion from './PageCompanion';
import { useContactContext, type CurrentPage } from './ContactProvider';
interface ContactButtonProps {
  render: (props: {
    onClick: (e: React.MouseEvent) => void;
  }) => React.ReactNode;
}
export default function ContactButton(t0) {
  const $ = _c(39);
  const {
    render
  } = t0;
  const {
    helpType,
    isDialogOpen,
    currentPage,
    shouldDisplayBack,
    toggleHelpType,
    openDialog,
    closeDialog,
    goMainPage,
    changePage,
    aplOwner,
    supportChannel,
    isOwnerLoading
  } = useContactContext();
  let t1;
  if ($[0] !== changePage) {
    t1 = pageType => {
      if (pageType === "companion") {
        changePage({
          type: "companion",
          data: {
            initialMessage: ""
          }
        });
      } else {
        if (pageType === "email") {
          changePage({
            type: "email"
          });
        } else {
          changePage({
            type: pageType as 'main' | 'phone'
          } as CurrentPage);
        }
      }
    };
    $[0] = changePage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChangePageFromType = t1;
  let t2;
  if ($[2] !== changePage) {
    t2 = message => {
      changePage({
        type: "companion",
        data: {
          initialMessage: message
        }
      });
    };
    $[2] = changePage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSendMessage = t2;
  let t3;
  if ($[4] !== closeDialog) {
    t3 = (event, reason) => {
      closeDialog(reason);
    };
    $[4] = closeDialog;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClose = t3;
  let t4;
  if ($[6] !== openDialog) {
    t4 = e => {
      e.preventDefault();
      openDialog();
    };
    $[6] = openDialog;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== render || $[9] !== t4) {
    t5 = render({
      onClick: t4
    });
    $[8] = render;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== aplOwner || $[12] !== currentPage?.type || $[13] !== handleChangePageFromType || $[14] !== handleSendMessage || $[15] !== helpType || $[16] !== isOwnerLoading || $[17] !== supportChannel || $[18] !== toggleHelpType) {
    t6 = currentPage?.type === "main" && <PageMain onChangePage={handleChangePageFromType} onSendMessage={handleSendMessage} onSwitchHelpType={toggleHelpType} helpType={helpType} aplOwner={aplOwner} supportChannel={supportChannel} isOwnerLoading={isOwnerLoading} />;
    $[11] = aplOwner;
    $[12] = currentPage?.type;
    $[13] = handleChangePageFromType;
    $[14] = handleSendMessage;
    $[15] = helpType;
    $[16] = isOwnerLoading;
    $[17] = supportChannel;
    $[18] = toggleHelpType;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== currentPage?.type || $[21] !== goMainPage) {
    t7 = currentPage?.type === "phone" && <PagePhone onGoBack={goMainPage} />;
    $[20] = currentPage?.type;
    $[21] = goMainPage;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== currentPage || $[24] !== goMainPage) {
    t8 = currentPage?.type === "email" && <PageEmail onGoBack={goMainPage} ownerEmail={currentPage.data?.ownerEmail} />;
    $[23] = currentPage;
    $[24] = goMainPage;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== currentPage) {
    t9 = currentPage?.type === "companion" && <PageCompanion data={currentPage.data} />;
    $[26] = currentPage;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== handleClose || $[29] !== isDialogOpen || $[30] !== shouldDisplayBack || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
    t10 = <Dialog isOpen={isDialogOpen} onClose={handleClose} shouldDisplayBack={shouldDisplayBack}>{t6}{t7}{t8}{t9}</Dialog>;
    $[28] = handleClose;
    $[29] = isDialogOpen;
    $[30] = shouldDisplayBack;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t10 || $[37] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[36] = t10;
    $[37] = t5;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  return t11;
}